import http from './http'
import { getToken } from './auth'

const base = 'company/users'

export async function getUserById(id) {
    const { data } = await http.get(`${base}/${id}`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function getUsers() {

    const { data } = await http.get(`${base}/`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function getUsersAsOptions() {

    const { data } = await http.get(`${base}/as-options`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

// Avatar upload — sends the raw image file; the API stores it in the Supabase
// bucket and returns { avatarUrl }.
export async function uploadUserAvatar(id, file) {
    const { data } = await http.patch(`${base}/${id}/avatar`, file, {
        headers: {
            'Content-Type': file.type,
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

// Invite a user: { fullName, email, role }. The API derives the username and
// e-mails the invitee a link to choose their password.
export async function createUser(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken()
        }
    }

    const { data } = await http.post(base + '/create', payload, config)
    return data
}

// Re-send the invitation / set-password e-mail (issues a fresh link).
export async function resendInvite(id) {
    const { data } = await http.post(`${base}/${id}/resend-invite`, {}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

//TODO: not implement in api
export async function updateUser(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.patch(base + '/' + payload.id, payload, config)
    return data
}

//TODO: not implement in api
export async function deleteUser(id) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.delete(base + '/' + id, config)
    return data
}
